import { EnergiedatenPlausibel } from './EnergiedatenPlausibel';
import { IDs } from '../../helpers/IDs';
import * as Moment from 'moment';
import { StammdatenPlausibel } from './StammdatenPlausibel';

export function processPlausibilisierung(data: any) {
    const jahrMax = Moment().year();
    const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])
        .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
    const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;
    data.plausibel = {};
    const Stammdaten = new StammdatenPlausibel(data);

    for (let jahr: number = jahrMin; jahr <= jahrMax; jahr++) {
        const Energiedaten = new EnergiedatenPlausibel(data, jahr);
        data.plausibel[jahr] = [...Energiedaten.getData(), ...Stammdaten.getData()];
    }
}
